import { render, staticRenderFns } from "./ClientsTableList.vue?vue&type=template&id=3028255e&"
import script from "./ClientsTableList.vue?vue&type=script&lang=js&"
export * from "./ClientsTableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports